import { ActionTypes } from "../constants/action-types";
import { fromJS } from "immutable";
import { handleActions } from "redux-actions";

const initialState = fromJS({
  itemLinks: [],
});

export const actions = {
  [ActionTypes.getItemLink]: {
    next(state, data) {
      const { payload, error, pending } = data;
      if (error) {
        return state.merge({ error, pending });
      }
      if (pending) {
        return state.merge({ pending });
      }
      if (payload === null) {
        return state;
      }
      const newState = {
        ...state.toJS(),
        pending: false,
        itemLinks: payload || [],
      };
      return fromJS(newState);
    },
  },
};

export const itemLinkReducer = handleActions(actions, initialState);
